/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmdk_Dialog_DescriptionInputs */

const en_cmdk_dialog_description = /** @type {(inputs: Cmdk_Dialog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find things fast`)
};

const es_cmdk_dialog_description = /** @type {(inputs: Cmdk_Dialog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encuentra todo rápido`)
};

/**
* | output |
* | --- |
* | "Find things fast" |
*
* @param {Cmdk_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cmdk_dialog_description = /** @type {((inputs?: Cmdk_Dialog_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmdk_Dialog_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_cmdk_dialog_description(inputs)
	return en_cmdk_dialog_description(inputs)
});